export enum ReportsManagementActions {
    FETCH_AVAILABILITY_REGISTRY_DATA = 'FETCH_AVAILABILITY_REGISTRY_DATA',
    CREATE_AVAILABILITY_REPORT = 'CREATE_AVAILABILITY_REPORT',
    FETCH_INCIDENT_REGISTRY_VIEW = 'FETCH_INCIDENT_REGISTRY_VIEW',
    CREATE_INCIDENT = 'CREATE_INCIDENT',
    FETCH_HISTORY_REPORTS = 'FETCH_HISTORY_REPORTS',
    FETCH_HISTORY_INCIDENTS = 'FETCH_HISTORY_INCIDENTS',
    DOWNLOAD_REPORTS = 'DOWNLOAD_REPORTS',
    DOWNLOAD_INCIDENTS = 'DOWNLOAD_INCIDENTS',
}
